import React, { useContext, useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import { toast } from 'react-toastify'
import { FiPlus, FiSave, FiTrash } from 'react-icons/fi'

import { Container } from './styles'
import Card from '../../../../components/Card'
import { TipContext } from '../../../../contexts/TipContext'
import { loadTips } from '../../../../util/tip'
import { api, authHeaders } from '../../../../services/api'
import { GlobalContext } from '../../../../contexts/GlobalContext'
import Table from '../../../../components/Table'
import Spinner from '../../../../components/Spinner'
import { Button, Textbox } from '../../../../components/Form'
import Modal from '../../../../components/Modal'
import masks from '../../../../util/masks'
import Yup from '../../../../services/yup'
import { validarCPF } from '../../../../util/validadores'

const validation = Yup.object({
	nome: Yup.string().required('Informe o nome do avaliador.'),
	email: Yup.string().email('E-mail inválido.').required('Informe o e-mail do avaliador.'),
	nome: Yup.string().required('Informe o nome'),
	cpf: Yup.string().required('Informe o CPF do avaliador.')
		.test('validar-cpf', 'CPF inválido.', value => validarCPF(value || ''))
})

export default function () {
	const { checkException } = useContext(GlobalContext)
	const { setCodigo, tips } = useContext(TipContext)

	const [avaliadores, setAvaliadores] = useState(null)
	const [showModalCadastro, setShowModalCadastro] = useState(false)

	async function loadAvaliadores() {
		try {
			const response = await api.get(`instituicao/avaliadores`, authHeaders())

			setAvaliadores(response.map(item => ({
				id: item.pessoa.id,
				nome: item.pessoa.nome
			})))
		} catch(e) {
			checkException(e)
		}
	}

	async function handleRemoverAvaliador(avaliador) {
		try {
			await api.delete(`instituicao/avaliador/${avaliador.id}`, authHeaders())

			toast.success('Avaliador removido.')

			loadAvaliadores()
		} catch(e) {
			checkException(e)
		}
	}

	async function handleCadastrar(values) {
		try {
			await api.post('instituicao/avaliador', values, authHeaders())

			toast.success('Avaliador cadastrado.')

			loadAvaliadores()

			setShowModalCadastro(false)
		} catch(e) {
			checkException(e)
		}
	}

	useEffect(() => {
		loadAvaliadores()
	}, [])

	useEffect(() => {
		loadTips(setCodigo, 'form_avaliadores')
	}, [])

	if(!avaliadores) {
		return (
			<Container>
				<main>
					<Card className="flex flex-col">
						<Spinner />
					</Card>
				</main>
			</Container>
		)
	}

	return (
		<>
			<Container>
				<main>
					<Card className="flex flex-col">
						<h1>Avaliadores indicados</h1>

						<p className="mt-4 ml-2">{tips.formulario}</p>

						<Button className="transparent w-fit self-end" onClick={() => { setShowModalCadastro(true) }}>
							Cadastrar novo avaliador
							<FiPlus size={16} />
						</Button>

						<Table 
							headers={[
								{ name: 'nome', value: 'Avaliador' },
								{ name: 'cpf', value: 'CPF' }
							]}
							data={avaliadores}
							actions={[
								{
									action: handleRemoverAvaliador,
									name: 'remover',
									icon: FiTrash,
									iconSize: 16,
									confirmation: 'Deseja realmente remover este avaliador?'
								}
							]}
						/>
					</Card>
				</main>
			</Container>

			<Modal
				isOpen={showModalCadastro}
				handleClose={() => {
					setShowModalCadastro(false)
					
				}}
				title="Cadastro de avaliadores"
			>
				<Formik
					onSubmit={handleCadastrar}
					initialValues={{
						nome: '',
						cpf: '',
						email: ''
					}}
					enableReinitialize
					validationSchema={validation}
				>
					{() => {
						return (
							<Form className="mt-4 flex flex-col lg:grid lg:grid-cols-2">
								<Textbox name="nome" label="Nome" />

								<Textbox name="cpf" label="CPF" mask={masks.cpf} />
								
								<Textbox name="email" label="E-mail" />

								<Button type="submit" className="white w-fit self-end justify-self-end" style={{ marginTop: 16 }}>
									Cadastrar
									<FiSave size={16} />
								</Button>
							</Form>
						)
					}}
				</Formik>
			</Modal>
		</>
	)
}
